import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.exchanges;

export const exchangesSelector = createSelector(getState, (state) => state.exchanges);
export const receiveExchangesSelector = createSelector(getState, (state) => state.receiveExchanges);
export const iaLoadingExchangesSelector = createSelector(
  getState,
  (state) => state.iaLoadingExchanges,
);

export const exchangeSelector = createSelector(getState, (state) => state.exchange);
export const isLoadingExchangeSelector = createSelector(
  getState,
  (state) => state.isLoadingExchange,
);

export const exchangesMerchantSelector = createSelector(getState, (state) => state.merchants);
export const receivedMerchantsSelector = createSelector(
  getState,
  (state) => state.receivedMerchants,
);

export const exchangesParsersSelector = createSelector(getState, (state) => state.parsers);

export const statusesSelector = createSelector(getState, (state) => state.statuses);

export const givenFiltersSelector = createSelector(getState, (state) => state.givenFilters);
export const receivedFiltersSelector = createSelector(getState, (state) => state.receivedFilters);
